import { useState } from 'react';
import useContext from '../../../context';

const dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

function ClosingCostItem({ context, updateContext, item, sub = false }) {
  const editable = item.key === 'annualdues';
  const editedField = 'annualDues';

  const [editEnabled, setEditEnabled] = useState(false);

  const value = (editable && context[editedField] > 0) ? context[editedField] : item.value;

  const classes = ['optioncard__item'];

  if (sub) {
    classes.push('-sub', '-ignore');
  }

  // Financed closing costs reduce the cash due, so the row is styled apart from the fees
  if (item.key === 'closing_costs_financed') {
    classes.push('-financed');
  }

  return (
    <React.Fragment>
      <div className={classes.join(' ')}>
        <span className="optioncard__item-title">{item.label}</span>
        <span className="optioncard__item-value">
          { editable && <button type="button" onClick={() => setEditEnabled(true)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
            </svg>
            <span className="srt">Edit</span>
          </button> }
          {
            editEnabled
              ? <input autoFocus type="number" name={item.label} defaultValue={value} onBlur={({ target: { value } }) => {
                updateContext((ctx) => {
                  ctx[editedField] = value;

                  return ctx;
                });

                setEditEnabled(false);
              }} />
              : `${item.operator === '-' ? '-' : ''}${dollars.format(value)}`
          }
        </span>
      </div>
      {
        item.subItems && item.subItems.map((subItem) => <ClosingCostItem key={subItem.key || subItem.label} context={context} updateContext={updateContext} item={subItem} sub/>)
      }
    </React.Fragment>
  )
}

export default function ClosingCostDetails({ option }) {
  const [open, setOpen] = useState(false);
  const [context, updateContext] = useContext();

  if (!context.response[option].estimated_cash_details) {
    return null;
  }

  const estimates = context.response[option].estimated_cash_details;

  return (
    <React.Fragment>
      <div className="optioncard__show-wrapper">
        <button
          className={`${open ? 'optioncard__show--active' : ''} optioncard__show`}
          onClick={() => setOpen(!open)}
        >
          Show details <i className="fas fa-angle-down" />
        </button>
      </div>
      <div className={`${open ? 'optioncard__detail--active' : ''} optioncard__detail`}>
        {
          estimates.map((item) => <ClosingCostItem key={item.key || item.label} context={context} updateContext={updateContext} item={item} />)
        }
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanCards/components/ClosingCostDetails.js